import React from "react";
import { INITIAL_STATE } from "../../redux/modules/lsevent";

export const LSEventContext = React.createContext(INITIAL_STATE);
